import React from 'react'
import { ConfirmationDialog, ModalInjectedProps } from '@sketch/components'
import { useToast } from '@sketch/toasts'
import {
  useRemoveIntegrationIdentityMutation,
  GetIntegrationIdentitiesDocument,
} from '@sketch/gql-types'

interface UnlinkIntegrationIdentityModalProps extends ModalInjectedProps {
  integrationName: string
  identityId: string
  workspaceId: string
}

export const UnlinkIntegrationIdentityModal: React.FC<
  UnlinkIntegrationIdentityModalProps
> = ({ hideModal, integrationName, identityId, workspaceId }) => {
  const { showToast } = useToast()

  const [removeIntegrationIdentity, { loading }] =
    useRemoveIntegrationIdentityMutation({
      onCompleted: () => {
        showToast(`Your ${integrationName} account has been unlinked`)
        hideModal()
      },
      onError: ({ message }) => {
        showToast(message || 'Something went wrong', 'negative')
      },
      refetchQueries: [
        {
          query: GetIntegrationIdentitiesDocument,
          variables: { identifier: workspaceId },
        },
      ],
      awaitRefetchQueries: true,
    })

  const handleConfirm = () => {
    removeIntegrationIdentity({
      variables: { identifier: identityId },
    })
  }

  return (
    <ConfirmationDialog
      title={`Are you sure you want to disconnect your ${integrationName} account?`}
      hideModal={hideModal}
      onConfirm={handleConfirm}
      confirmButton={{
        text: 'Unlink',
        loading,
        variant: 'negative-secondary',
      }}
    >
      <p>
        You&apos;ll no longer receive notifications from Sketch in{' '}
        {integrationName}, including new comments or replies on documents you
        follow.
      </p>
    </ConfirmationDialog>
  )
}
